import { Flex, Text, Badge, Spacer } from '@chakra-ui/react'
import { FC, useMemo } from 'react'

import useParametrizationConfigTolerancia from '@hook/parametrization/use-config-tolerancia'

import { canManagePurchaseApprovalRules } from '@helper/parametrization/purchaseConfigAuth'

import ModalCreateTolerancia from './Tolerancia/ModalCreateTolerancia'
import ParametrizationToleranciaPurchasetModalDelete from './Tolerancia/ModalDeleteTolerancia'
import ModalUpdateTolerancia from './Tolerancia/ModalUpdateTolerancia'

const SelectedTableBarReabCronPurchaseTolerancia: FC = () => {
  const { selectedTolerancia } = useParametrizationConfigTolerancia()
  // Só controle de interface: a API também precisa validar o perfil
  const canManage = useMemo(() => canManagePurchaseApprovalRules(), [])

  return (
    <Flex
      borderBottom="solid 1px"
      borderColor="gray.200"
      alignItems="center"
      justifyContent="space-between"
      paddingY={2}
      paddingX={4}
    >
      <Flex alignItems="center">
        <Badge
          h="16px"
          minW="16.5px"
          marginRight={2}
          ml="1"
          color="#4b64c9"
          border="1px solid #4b64c9"
          background="#c0d9ff"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {selectedTolerancia ? 1 : 0}
        </Badge>
        <Text color={'black'}>Itens Selecionados</Text>
      </Flex>

      <Spacer />

      {!canManage ? (
        <Text fontSize="sm" color="gray.500">
          Somente visualização (criação/edição restrita a Administrador e
          Diretor)
        </Text>
      ) : selectedTolerancia > 0 ? (
        <>
          <ParametrizationToleranciaPurchasetModalDelete />
          <ModalUpdateTolerancia />
        </>
      ) : (
        <ModalCreateTolerancia />
      )}
    </Flex>
  )
}

export default SelectedTableBarReabCronPurchaseTolerancia
